import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { PurchaseOrder } from '../../../models/PurchaseOrder.model';
import { PurchaseOrderService } from '../../../services/purchaseOrder.service';
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { ExcellenceCenter } from "../../../models/ExcellenceCenter.model";
import { Dimension } from "../../../models/PurchaseOrder.model";
import * as moment from 'moment';

@Component({
    selector: 'app-purchase-order-detail',
    templateUrl: './purchase-order-detail.component.html',
    styleUrls: ['./purchase-order-detail.component.css']
})
export class PurchaseOrderDetailComponent implements OnInit {
    loading: boolean;
    competences = this.competenceProvider.competences;
    purchaseOrder: PurchaseOrder = new PurchaseOrder();
    commonHelper: CommonHelper = new CommonHelper();
    loggedUser;

    checkUpdateStatus: boolean = false;
    purchaseApproved: boolean = true;
    showSaveButton: boolean = false;
    isApprover: boolean = false;

    allPurchaseOrdersIfAnticipation = new Array<PurchaseOrder>();
    anticipationTotalValue: number = 0;
    anticipationAmount: number = 0;
    isAnticipation: boolean = false;
    isRequester: boolean = false;
    anticipationModalTitle = '';
    anticipationModalMessage = '';

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public toastr: ToastsManager,
        public localStorage: LocalStorage,
        public competenceProvider: CompetenceProvider,
        public purchaseService: PurchaseOrderService,
        private errorHandler: ErrorHandlerProvider
    ) { }

    async ngOnInit() {
        this.loading = true;
        const id = this.route.snapshot.params['id'];
        this.loggedUser = this.localStorage.retrieve('user');
        const purchaseOrderResponse = await this.purchaseService.getById(id);

        if (!purchaseOrderResponse._id) {
            this.errorHandler.interceptError(purchaseOrderResponse, 'Pedido de Compra')
            this.router.navigate(['/purchase-orders']);
        }

        this.purchaseOrder = purchaseOrderResponse;

        if (this.purchaseOrder && this.purchaseOrder.anticipationCode) {
            const allOrders = await this.purchaseService
                .getPurchaseOrderByAnticipationCode(this.purchaseOrder.anticipationCode)
            const sortOrders = allOrders.sort((a, b) => Number(a.competenceYear) - Number(b.competenceYear))
                .sort((a, b) => Number(a.competence) - Number(b.competence))
            this.allPurchaseOrdersIfAnticipation = [...sortOrders];
            this.sumAllPurchaseOrdersAnticipationValues();
            this.isAnticipation = true;
        }

        this.checkMatchBetweenPurchaseAndApprover();

        this.loading = false;
    }

    sumAllPurchaseOrdersAnticipationValues() {
        if (this.allPurchaseOrdersIfAnticipation && this.allPurchaseOrdersIfAnticipation.length > 0) {
            this.anticipationTotalValue = this.allPurchaseOrdersIfAnticipation.reduce((acc, {value}) => acc + value, 0);
            this.anticipationAmount = this.allPurchaseOrdersIfAnticipation.length;
        }
    }

    checkMatchBetweenPurchaseAndApprover() {
        const approverOfPurchase = this.purchaseOrder.managers.find(m => m.email === this.loggedUser.username);
        if(approverOfPurchase) this.isApprover = true;
        if(approverOfPurchase && !approverOfPurchase.approved && this.purchaseOrder.status == 1) {
            this.showSaveButton = true;
        }
    }

    async saveAnticipation() {
        try {
            this.loading = true;
            if (this.showSaveButton) {
                if (!this.purchaseApproved) {
                    this.allPurchaseOrdersIfAnticipation = this.allPurchaseOrdersIfAnticipation
                        .map((pOrder: PurchaseOrder) => ({...pOrder, status: 4})) as PurchaseOrder[]
                } else {
                    const purchaseOrdersIds = this.allPurchaseOrdersIfAnticipation
                        .map((pOrder: PurchaseOrder) => String(pOrder._id))
                    const { username } = this.loggedUser;

                    const responsePurchaseOrdersApproval = await this.purchaseService
                        .recurrenceApproval(purchaseOrdersIds, { manager: { username }});

                    if (responsePurchaseOrdersApproval && responsePurchaseOrdersApproval.length > 0) {
                        this.loading = false;
                        this.toastr.success('Pedido de Compra atualizado com sucesso');
                        this.router.navigate(['/purchase-orders']);
                        return;
                    } else {
                        this.errorHandler.interceptError(responsePurchaseOrdersApproval, 'Pedido de Compra');
                        this.router.navigate(['/purchase-orders']);
                        return;
                    }
                }
            }
            const response = await this.purchaseService.recurrenceRepproval(this.allPurchaseOrdersIfAnticipation);
            if(response && response.length > 0)
                this.toastr.success('Pedidos de Compra atualizados com sucesso');
            else
                this.errorHandler.interceptError(response, 'Pedido de Compra');
            this.loading = false;
            this.router.navigate(['/purchase-orders']);
        } catch (error) {
            console.log(error)
            this.loading = false;
        }
    }

    async savePurchase() {
        try{
            this.loading = true;
            if(this.showSaveButton){
                if(!this.purchaseApproved) {
                    this.purchaseOrder.status = 4;
                } else {
                    let respApproval = await this.purchaseService.approval(this.purchaseOrder._id, {
                        manager: this.loggedUser
                    });
                    if(respApproval._id) {
                        this.loading = false;
                        this.toastr.success('Pedido de Compra atualizado com sucesso');
                        this.router.navigate(['/purchase-orders']);
                        return;
                    } else {
                        this.errorHandler.interceptError(respApproval, 'Pedido de Compra');
                        this.router.navigate(['/purchase-orders']);
                        return;
                    }
                }
            }

            const response = await this.purchaseService.update(this.purchaseOrder);
            if(response._id)
                this.toastr.success('Pedido de Compra atualizado com sucesso');
            else
                this.errorHandler.interceptError(response, 'Pedido de Compra');
            this.loading = false;
            this.router.navigate(['/purchase-orders']);
        } catch(err){
            this.loading = false;
            console.log(err);
            this.router.navigate(['/purchase-orders']);
            this.errorHandler.interceptError(err, 'Pedido de Compra');
        }
    }

    OnCancel() {
        this.router.navigate(['/purchase-orders']);
    }

    checkIfApprover(center: ExcellenceCenter, centerFieldName: string) {
        if ((center && center._id) && (this.loggedUser[centerFieldName] && this.loggedUser[centerFieldName].length)) {
            const foundCenter = this.loggedUser[centerFieldName].find((userCenter: {_id: string, name: string}) => String(userCenter._id) === String(center._id))
            if (foundCenter) {
                return "Você está realizando a aprovação deste Centro de Custo"
            }
        }
        return ''
    }

    verifyRequesterOrStatus(): string {
        if (this.purchaseOrder.status != 1 || !this.isRequester) {
            return 'disable'
        }
        return ''
    }

    getCustomClassForAntecipation(): string {
        return !!this.purchaseOrder.anticipation && !!this.purchaseOrder.anticipation.startDate ? 'col-md-4' : 'col-md-6';
    }

    formatAnticipationDates(date: string): string {
        if (!!date) {
            return moment(date).utc().format('MMMM/YYYY');
        }
    }

    getAnticipationApprovaOrRepprovalInfo(): string {
        if (!this.purchaseApproved) {
            this.anticipationModalTitle = 'Você realmente deseja reprovar este Pedido de Compra (Antecipação)?';
            this.anticipationModalMessage = 'Caso seja reprovado, todos os outros Pedidos de Compra (Antecipação) que estão vinculados exceto pedidos que já estão como "Pago", serão atualizados.';
            return;
        }
        this.anticipationModalTitle = 'Você realmente deseja aprovar este Pedido de Compra (Antecipação)?';
        this.anticipationModalMessage = 'Caso seja aprovado, todos os outros Pedidos de Compra (Antecipação) que estão vinculados, serão atualizados.';
    }
}



// WEBPACK FOOTER //
// ./src/app/views/purchase-order/purchase-order-detail/purchase-order-detail.component.ts